import type { Content } from "@prismicio/client"
import type { SliceComponentProps } from "@prismicio/react"

import { PNImage } from "@bounce/web-components"

/**
 * Props for `InlineImage`.
 */
export type InlineImageProps = SliceComponentProps<Content.InlineImageSlice>

/**
 * Component for "InlineImage" Slices.
 */
const InlineImage = ({ slice }: InlineImageProps): JSX.Element => {
  return (
    <PNImage
      src={slice.primary.image1}
      loading="lazy"
      fallbackAlt=""
      width={768}
      imgixParams={{ fit: "max", w: 768 }}
      className="my-12 w-full bg-neutral-100 object-contain object-center"
    />
  )
}

export default InlineImage
